module.exports = __webpack_public_path__ + "media/images/author-f-36fef53c4d208bdbf138dd9149305ba1.png";